import React from 'react';
import { SkeletonProps } from '../../interfaces/SkeletonProps';
import Refresh from '../Refresh/Refresh';
import PlaceholderBar from '../PlaceholderBar/PlaceholderBar';
import { useTranslation } from 'react-i18next';
import styles from './InMemoryTotal.scss';
import classNames from 'classnames';

const InMemoryTotalSkeleton: React.FunctionComponent<SkeletonProps> = ({
  animated,
  displayRefreshButton,
  onRefresh,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <Refresh
      className={classNames(
        'jg-display-flex jg-flex-column jg-flex-aic',
        styles.skeleton,
      )}
      displayRefreshButton={displayRefreshButton}
      onRefresh={onRefresh}
      buttonLabel={t('inMemory.total.refresh')}
    >
      <PlaceholderBar width="75%" height={36} animated={animated} />
      <PlaceholderBar width="50%" height={18} animated={animated} />
      <PlaceholderBar
        width="60%"
        height={18}
        animated={animated}
        className="jg-space-mbn"
      />
    </Refresh>
  );
};

export default InMemoryTotalSkeleton;
